import { createSlice } from '@reduxjs/toolkit';
import { get as lodashGet } from 'lodash-es';

import { IUserSupplementImageSettings } from '@interfaces/supplements';

import { handleGetUserSupplementSettings } from './actions';
import { IUserSupplementSettings } from './slice.interface';

const initialState: IUserSupplementSettings = {
  allowedFileExtensionsInquiryUpload: [],
  maxFileSizeInquiryUploadMb: 0,
  isLoading: false,
  isReady: false,
  error: false,
};
export const userSupplementSettingsSlice = createSlice({
  name: 'supplement-settings',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(handleGetUserSupplementSettings.pending, (state: IUserSupplementSettings) => {
        state.isLoading = true;
        state.error = false;
      })
      .addCase(handleGetUserSupplementSettings.rejected, (state: IUserSupplementSettings) => {
        state.isLoading = false;
        state.error = true;
      })
      .addCase(
        handleGetUserSupplementSettings.fulfilled,
        (state: IUserSupplementSettings, action) => {
          const data = lodashGet(action, 'payload.data', {});
          const { allowedFileExtensionsInquiryUpload, maxFileSizeInquiryUploadMb } =
            data as IUserSupplementImageSettings;
          state.allowedFileExtensionsInquiryUpload = Array.isArray(
            allowedFileExtensionsInquiryUpload,
          )
            ? allowedFileExtensionsInquiryUpload
            : [];
          state.maxFileSizeInquiryUploadMb = maxFileSizeInquiryUploadMb || 0;
          state.isLoading = false;
          state.isReady = true;
        },
      );
  },
});
export default userSupplementSettingsSlice.reducer;
